import { useGLTF } from '@react-three/drei';
import type { Euler, Vector3 } from '@react-three/fiber';
import type { ReactElement } from 'react';
import { useRef } from 'react';
import * as THREE from 'three';
import type { GLTF } from 'three-stdlib';

type GLTFResult = GLTF & {
  nodes: {
    fox: THREE.Mesh;
  };
};
interface FoxProps {
  color?: string;
  position?: Vector3;
  scale?: Vector3;
  rotation?: Euler;
}

const Fox = ({ color, position, rotation, scale }: FoxProps): ReactElement => {
  const { nodes } = useGLTF('/assets/3d/Fox-draco.glb') as unknown as GLTFResult;

  const group = useRef<THREE.Group>(null);
  const refModel = useRef(null);

  const material = new THREE.MeshPhongMaterial({
    color: color || '#070707',
    shininess: 7,
  });

  return (
    <group ref={group} position={position} rotation={rotation} scale={scale} dispose={null}>
      <mesh
        ref={refModel}
        geometry={nodes.fox.geometry}
        material={material}
        position={[0, 0, 0]}
        scale={[2, 2, 2]}
        rotation={[0, 0, 0]}
        castShadow
      />
      <meshStandardMaterial color="#003300" attach="material" />
    </group>
  );
};

// useGLTF.preload('/assets/3d/Fox-draco.glb');

export default Fox;
